import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

/** Fecha de calendario en formato YYYY-MM-DD, que es el que usa la API. */
export const toApiDate = (date = new Date()) => format(date, 'yyyy-MM-dd');

export const todayApi = () => toApiDate(new Date());

export const firstDayOfMonth = () => {
  const now = new Date();
  return toApiDate(new Date(now.getFullYear(), now.getMonth(), 1));
};

const safeParse = (value) => {
  if (!value) return null;
  try {
    const parsed = typeof value === 'string' ? parseISO(value) : value;
    return isNaN(parsed.getTime()) ? null : parsed;
  } catch {
    return null;
  }
};

export const formatDate = (value) => {
  const parsed = safeParse(value);
  return parsed ? format(parsed, "dd MMM yyyy", { locale: es }) : '—';
};

export const formatDateTime = (value) => {
  const parsed = safeParse(value);
  return parsed ? format(parsed, "dd MMM yyyy · HH:mm", { locale: es }) : '—';
};

export const formatTime = (value) => {
  const parsed = safeParse(value);
  return parsed ? format(parsed, 'HH:mm') : '—';
};

/** Valor para <input type="datetime-local">, que no acepta zona horaria. */
export const toDateTimeLocal = (value) => {
  const parsed = safeParse(value);
  return parsed ? format(parsed, "yyyy-MM-dd'T'HH:mm") : '';
};

export const isPast = (value) => {
  const parsed = safeParse(value);
  return parsed ? parsed.getTime() < Date.now() : false;
};
